import store from "./module/store";

export default {
  name: "toolbox",
  routes: [],
  store: store
};
